import React, { useEffect, useState, useRef } from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HttpHelper from '../../service/httpService'
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission } from "../../service/userService";
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";
import { AiOutlineEye } from 'react-icons/ai';

const SecurityObjectName = 'Website.AboutSection';

const DashboardAboutUs = (props) => {

    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,FontName,
        FormatBlock,
        Link,
        Unlink,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;

    const editor = useRef();
    const [contentData, setContentData] = useState("");

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const [aboutUs, setHomeAboutSection] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [isEditing, setIsEditing] = useState(false);
    const [aboutHomeImage, setAboutHomeImage] = useState(null);
    const [homeAboutIdUpdate, setHomeAboutIdUpdate] = useState();
    const [fileIdUpdate, setFileIdUpdate] = useState();
    const [fileDetailsUpdate, setFileDetailsUpdate] = useState();
    const [rowVersion, setRowVersion] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);

    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            if (data && data.file && data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("AboutUs/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        if (homeAboutIdUpdate !== '') {
                            HomeAboutSectionUpdate(data, homeAboutIdUpdate, fileIdUpdate, response.data[0], data.FileId);
                        }
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                HomeAboutSectionUpdate(data, homeAboutIdUpdate, fileIdUpdate, fileDetailsUpdate, false);
                //props.showToast('error', 'Please add image');
            }
        } else {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("AboutUs/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        HomeAboutSectionAdd(data, data.FileId)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            }
        }

    };
    const HomeAboutSectionAdd = async (data, fileId) => {
        delete data.SectionId;
        if (fileId) {
            await HttpHelper.post("AboutUs", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                setIsEditing(true);
                props.showToast('success', 'Record Added Succesfully');
                GetHomeAboutSection();
                BlankDetails();
            }).catch((error) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
            })
        } else {
            await HttpHelper.post("AboutUs", data).then((response) => {
                setIsEditing(true);
                setLoaderApi(false);
                setPopupAddEdit(false);
                props.showToast('success', 'Record Added Succesfully');
                GetHomeAboutSection();
                BlankDetails();
            }).catch((error) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
            })
        }

    }
    const HomeAboutSectionUpdate = async (data, homeAboutIdUpdate, fileId, fileDetails, hasFile) => {
        if (hasFile) {
            Object.assign(data,
                { rowVersion: rowVersion },
                { primaryKeyEncrypted: primaryKeyEncrypted },
                { SectionId: homeAboutIdUpdate },
                { FileId: fileId },
                { file: fileDetails }
            );
            await HttpHelper.put("AboutUs", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                setIsEditing(true);
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                GetHomeAboutSection();
                BlankDetails();
                props.showToast('success', 'Record Updated Succesfully');
            }).catch((error) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
            })
        } else {
            Object.assign(data,
                { rowVersion: rowVersion },
                { primaryKeyEncrypted: primaryKeyEncrypted },
                { SectionId: homeAboutIdUpdate },
                { FileId: fileIdUpdate }
            );
            delete data.file;
            await HttpHelper.put("AboutUs", data).then((response) => {
                setIsEditing(true);
                setLoaderApi(false);
                setPopupAddEdit(false);
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                GetHomeAboutSection();
                BlankDetails();
                props.showToast('success', 'Record Updated Succesfully');
            }).catch((error) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
            })
        }

    }

    const GetHomeAboutSection = async (data) => {
        setLoaderApi(true);
        await HttpHelper.get("AboutUs", data).then((response) => {
            setHomeAboutSection(response.data.data);
            getAllPermission();
            setLoaderApi(false);
        }).catch((error) => {
            console.log(error);
        })

    }

    const DeleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("AboutUs/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const UpdateEditHomeAboutSection = async (elem) => {

        setIsEditing(true);
        setShowLoader(true);
        setPopupAddEdit(true);
        setLoaderApi(true);

        await HttpHelper.get("AboutUs/" + elem).then((response) => {
            console.log(response.data)
            setValue('Heading', response.data.heading);
            setValue('Content', response.data.content);
            setValue('Order', response.data.order);
            setValue('file', response.data.file);
            setHomeAboutIdUpdate(response.data.sectionId);
            setRowVersion(response.data.rowVersion);
            setFileIdUpdate(response.data.fileId);
            setContentData(response.data.content);
            setFileDetailsUpdate(response.data.file);
            setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted);

            setShowLoader(false);
            accordianStatusHandle('1');
            setPopupAddEdit(true);
            setLoaderApi(false);

        }).catch((error) => {
            setShowLoader(false);
            console.log(error);
        })
    }

    const BlankDetails = () => {
        setValue('Heading', '');
        setValue('SubHeading', '');
        setValue('Content', '');
        setValue('file', '');
        setValue('Order', '');
        setHomeAboutIdUpdate('');
        setRowVersion('');
        setPrimaryKeyEncrypted('')
        setShowLoader(false)
        setFileIdUpdate('');
        setContentData('');
        setFileDetailsUpdate('');
    }
    const accordianStatusHandle = (elem) => {
        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }
    useEffect(() => {
        GetHomeAboutSection();
        setIsEditing(true);
    }, []);

    return (
        <>
            <DashboardWrapper>
                <ToastContainer />
                <div className="DashboardWrapperChild">
                    <Sidebar />
                    <div className="contentWrapper">
                        <HeaderDashboard title="About Us" />
                        <div className="container-fluid mt-80 p-0">
                            <div className="row">
                                {hasAddPermissionUser == true ? <div className="col-md-2">
                                </div> : ''}
                                <div className="col-md-12 mb-2">
                                </div>

                                {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2 table-responsive">
                                    <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                        <table className="table tableCustomized table-striped">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Order
                                                    </th>
                                                    <th>
                                                        Heading
                                                    </th>
                                                    <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                        Image
                                                    </th>
                                                    <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    aboutUs.length > 0 && aboutUs.map((elem, index) => {
                                                        return (<tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{elem.heading}</td>
                                                            <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                {
                                                                    elem.file && elem.file.fileUrl ? < img src={elem.file.fileUrl} width="30" height="30" /> : null
                                                                }
                                                            </td>
                                                            {
                                                                hasAddPermissionUser || hasDeletePermissionUser ?
                                                                    <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                        {hasEditPermissionUser == true ?
                                                                            <svg onClick={() => UpdateEditHomeAboutSection(elem.primaryKeyEncrypted)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000" className="bi bi-pen" viewBox="0 0 16 16">
                                                                                <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                                                                            </svg> : ''
                                                                        }
                                                                    </td> : ''
                                                            }
                                                        </tr>);
                                                    })
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                    <div className="crossPopup" onClick={() => {
                        setShowImgPopup(false);
                        setImageCurrentShow('');
                    }}>
                        <RxCross1 />
                    </div>
                    <img src={imageCurrentShow} />
                </div>

                {hasEditPermissionUser || hasAddPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                    <div className="popupEditAndAddForm">
                        <div className="popupEditAndAddFormCloseButton" onClick={() => {
                            setPopupAddEdit(false);
                            setIsEditing(true);
                        }} >
                            <RxCross2 />
                        </div>

                        {loaderApi == true ? <div className="loaderApi">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div> : <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Home About Section" : "Create Home About Section"}</h4>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Heading:</label>
                                        <input type="text"  {...register("Heading")} className="border mb-2" placeholder="Heading" />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Order:</label>
                                        <input type="text"  {...register("Order")} className="border mb-2" placeholder="Order" />
                                    </div>
                                    <div className="col-md-12">
                                        <label>File: {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                        <br />
                                        <label>{fileDetailsUpdate != null ? fileDetailsUpdate.originalFileName : ''} </label>
                                        <input type="file" accept="image/png, image/jpeg, image/gif" {...register('file', { required: isEditing === true ? false : true })} className="border mb-2 w-100 is-invalid" />
                                        {errors.file?.type === 'required' && <p className="text-danger" role="alert">Image is required</p>}
                                    </div>

                                    <div className="col-md-12">
                                        <label>Content : < span class="requiredAstric"> *</span></label>
                                        <Editor className="border" placeholder="Content"
                                            tools={[
                                                [Bold, Italic, Underline, Strikethrough],
                                                [Subscript, Superscript],
                                                [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                [Indent, Outdent],
                                                [OrderedList, UnorderedList],
                                                FontSize,FontName,
                                                FormatBlock,
                                                [Undo, Redo],
                                                [Link, Unlink, ViewHtml],
                                                [InsertTable],
                                                [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                [DeleteRow, DeleteColumn, DeleteTable],
                                                [MergeCells, SplitCell],
                                            ]}
                                            ref={editor}
                                            defaultContent={contentData}
                                            onChange={(e) => {
                                                const regex = /(<([^>]+)>)/gi;
                                                const result = e.html.replace(regex, "");
                                                if (result.length > 0)
                                                    setValue('Content', e.html);
                                                else
                                                    setValue('Content', null);

                                            }}
                                        />
                                        <textarea className="border d-none" {...register("Content", { required: true })} placeholder="Content"></textarea>
                                        {errors.Content?.type === 'required' && <p className="text-danger" role="alert"> Content is required</p>}
                                        </div>
                                        <div className="col-md-12 d-flex justify-content-end mt-3">
                                            <div>
                                                <button className="btn btnSave mt-2">Save</button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                    </div>
                </div> : ''}

            </DashboardWrapper>
        </>
    )
}

export default DashboardAboutUs;